import {
  COUNTRY_LIST_DATA,
  ASYNC_FETCH,
  ASYNC_FETCH_FAILURE,
  ASYNC_FETCH_SUCCESS
} from './constants';

import httpClient, { getHttpClientRequest, postHttpClientRequest } from "../../../shared/services/httpClient";
import apiUrl from '../../../shared/utilities/apiUrl';

export const contryListApi = (countryListByPlanUrl, postData) => dispatch => {
  dispatch(asyncFetch());
  const onSuccess = response => {
    dispatch(asyncCallStatus(response.data));
  };
  const onError = error => {
    dispatch(asyncFetchFailed(error));
  };
  const callMS = (postData) => {
    var axConfig = {
      headers: { pageName: "planselection", subServiceName: "planselection" }
    };
    if (countryListByPlanUrl.indexOf("localhost") > -1) {
      return getHttpClientRequest(countryListByPlanUrl, axConfig);
    } else {
      return postHttpClientRequest(
        countryListByPlanUrl,
        postData,
        axConfig
      );
    }

  };
  callMS(postData)
    .then(msResp => {
      if (msResp && msResp.status == 200) {
        onSuccess(msResp);
      } else {
      }
    })
    .catch(onError);
};

export const asyncFetch = urlParams => ({
  type: ASYNC_FETCH,
  urlParams
});
export const asyncCallStatus = msResp => ({
  type: ASYNC_FETCH_SUCCESS,
  msResp
});
export const asyncFetchFailed = err => ({
  type: ASYNC_FETCH_FAILURE,
  err
});

export function setCountryListValue(data) {
  return {
    type: COUNTRY_LIST_DATA,
    data,
  };
}

export function countryListAction(data) {
  return {
    type: COUNTRY_LIST_DATA,
    data,
  };
}


